import { render, staticRenderFns } from "./StockStartPkgType.vue?vue&type=template&id=b9f5db50&scoped=true&"
import script from "./StockStartPkgType.vue?vue&type=script&lang=js&"
export * from "./StockStartPkgType.vue?vue&type=script&lang=js&"
import style0 from "./StockStartPkgType.vue?vue&type=style&index=0&id=b9f5db50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f5db50",
  null
  
)

export default component.exports